module.exports = __webpack_public_path__ + "img/menuDetail2.8470de6e.png";